import { Box, Typography } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import React from "react";

function SectionHeader(props) {
  const { subtitle, title, size, seoSize, subheadingSize, ...otherProps } = props;
  // Render nothing if no title or subtitle
  if (!title && !subtitle) {
    return null;
  }

  return (
    <Box
      component="header"
      sx={{
        // Add bottom margin if element below
        "&:not(:last-child)": {
          marginBottom: "1rem",
        },
      }}
      {...otherProps}
    >
      {title && (
        <Typography
          variant={`h${size}` as Variant}
          variantMapping={{ [`h${size}`]: `h${seoSize || size}` }}
          gutterBottom={!!subtitle}
        >
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography
          variant={subheadingSize?"subtitle1":`h${size + 1}` as Variant}
          variantMapping={{
              [`h${subheadingSize ?? (size + 1)}`]: `h${seoSize + 1 || (subheadingSize ?? (size + 1))}`,
          }}
          sx={{
              color: subheadingSize ? "#525352" : 'inherit',
              maxWidth: 700,
              display: "inline-block",
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export default SectionHeader;
